import React from "react";
import Tippy from "@tippyjs/react";
import type { Instance as TippyInstance, Placement, Props } from "tippy.js";

import "./ButtonWithDropdownOption.css";

interface ButtonWithDropdownOptionProps {
  placement?: Placement;
  children:
    | React.ReactNode
    | ((handleCloseTippy: () => void) => React.ReactNode);
  trigger: React.ReactElement;
  closeOnContentClick?: boolean;
  handleOutsideClick?: (instance: TippyInstance, event: Event) => void;
  offset?: [number, number];
  className?: string;
  onShow: () => void;
  onHide: () => void;
  isDisabled?: boolean;
}

function ButtonWithDropdownOption({
  placement = "bottom-end",
  children,
  trigger,
  closeOnContentClick = true,
  handleOutsideClick = () => {},
  offset = [0, 8],
  onShow,
  onHide,
  className = "",
  isDisabled = false,
  ...props
}: ButtonWithDropdownOptionProps) {
  const [tippyRef, setTippyRef] = React.useState<TippyInstance | null>(null);

  const handleCloseTippy = () => {
    if (tippyRef) {
      tippyRef.hide();
    }
  };

  const handleDropdownClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (closeOnContentClick) {
      handleCloseTippy();
    }
  };

  return (
    <Tippy
      interactive={true}
      trigger={isDisabled ? "manual" : "click"}
      zIndex={900}
      className={`button-with-dropdown-option ${className} export-download-container !bg-white`}
      onClickOutside={handleOutsideClick}
      arrow={false}
      offset={offset}
      placement={placement}
      content={[
        <div onClick={handleDropdownClick}>
          {typeof children === "function"
            ? children(handleCloseTippy)
            : children}
        </div>,
      ]}
      onCreate={setTippyRef}
      {...props}
    >
      {trigger}
    </Tippy>
  );
}

export default ButtonWithDropdownOption;
